export default function Terms() {
  return (
    <div style={styles.page}>
      <h1>Terms of Use</h1>

      <p>
        By accessing the FentaSafe platform, you agree to the following terms and
        conditions.
      </p>

      <h3>Demonstration Use</h3>
      <p>
        FentaSafe operates in demonstration mode using simulated data. It does
        not provide chemical confirmation or enforcement-grade detection.
      </p>

      <h3>No Liability</h3>
      <p>
        The platform is provided "as-is" for informational and demonstration
        purposes only. FentaSafe assumes no liability for decisions made based on
        demo data.
      </p>

      <h3>Access Control</h3>
      <p>
        Demo access may be protected using OTP-based verification.
      </p>

      <p style={styles.note}>
        These terms may be updated without prior notice.
      </p>
    </div>
  );
}

const styles = {
  page: {
    padding: "40px",
    maxWidth: "900px",
    color: "#0f172a",
    background: "#ffffff",
  },
  note: {
    marginTop: 20,
    fontSize: 14,
    color: "#64748b",
  },
};
